
import StackIcon from "@/assets/icons/StackIcon.vue";
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Amenity, CommunityQmiDetails, ComparedSvgFooterData, FooterData, LotCount, LotCountNeighborhood } from "../types";
import { apiMessages } from "./../api/message-api";
import { Status, OrderFooter } from "@/constant";
@Component({
  components: {
    StackIcon,
  }
})
export default class Footer extends Vue {
  private messages: any = {};
  private height=0;
  @Prop() private open!: boolean;
  @Prop() private selectedNeighborhoodIds!: string[];
  @Prop() private data!: FooterData[];
  @Prop() private amenities!: Amenity[];
  @Prop() private lotsCount!: LotCountNeighborhood[];
  @Prop() private futureHomePlans!: CommunityQmiDetails;
  @Prop() private matchedSvgfooterData!: ComparedSvgFooterData[]
  constructor() {
    super();
    this.loadMessages();
  }
  mounted()
  {
    this.changeFooterHeight();
  }
  async loadMessages() {
    const { messages } = await apiMessages("AppFooter");
    this.messages = messages;
  }
  updateFooter() {
    this.toggleFooter();
  }
  changeFooterHeight()
  {
    const legendDivHeight=document.getElementsByClassName("embfooter-card")[0];
    let resizeObserver = new ResizeObserver((entries, observer) => {
       this.height=(legendDivHeight as any).offsetHeight;
       document.documentElement.style.setProperty('--footerLegendHeight', `${this.height}px`);
    });
    resizeObserver.observe(legendDivHeight);
  }
  isPresentLotWithstatus(status: string) {
    const lotType = status
      .toLowerCase()
      .replace(" ", "")
      .replace("-", "");
    if(this.selectedNeighborhoodIds.length) {
      return this.lotsCount.find((neighborhoodLot) => neighborhoodLot.neighborhoodId === this.selectedNeighborhoodIds[0])?.[lotType];
    } else {
      for(const neighborhoodLot of this.lotsCount) {
        if (neighborhoodLot?.[lotType]) {
          return neighborhoodLot?.[lotType]
        }
      }
    }
  }
  @Emit("toggleFooter") toggleFooter() {
    return null;
  }
  @Emit("setLegends") setLegends(legends: string) { }
  sortFooter(updateFooterData: FooterData[]) {
    const sortedFooterData = [] as FooterData[];
    for(const order of OrderFooter){
      const data = updateFooterData.find((element)=> element.status === order);
      if(data){
        sortedFooterData.push(data);
      }
    }
    return sortedFooterData;
  }

  updateFooterAsSvgData(footerData: FooterData[]) {
    footerData.forEach((data, index) => {
      const matchedData = this.matchedSvgfooterData.filter((filteredData) => filteredData.status.includes(data.status.toLowerCase()));
      const updateNeighborhoods = matchedData.map(data => data.neighborhood_code);
      if(!updateNeighborhoods.length){
        footerData.splice(index,1);
      }else{
        data.neighborhoods = updateNeighborhoods;
      }
    })
  }
  footerFutureHomePlan(footerData: FooterData[]) {
    if((!this.selectedNeighborhoodIds.length && Object.keys(this.futureHomePlans).length) ||
      (Object.keys(this.futureHomePlans).includes(this.selectedNeighborhoodIds[0]))){
        footerData.push({
          color:'#CBBE98',
          neighborhoods:[...Object.keys(this.futureHomePlans)],
          status:Status.FUTURE_HOME
        })
      }
      this.updateFooterAsSvgData(footerData);
  }
  get footerData() {
    let futureHomeFooterData= this.data.filter((item) => this.isPresentLotWithstatus(item.status)) ||
      ([] as FooterData[]);
      this.footerFutureHomePlan(futureHomeFooterData);
      futureHomeFooterData = this.sortFooter(futureHomeFooterData);
      if(this.selectedNeighborhoodIds.length){
        futureHomeFooterData = futureHomeFooterData.filter(data => data.neighborhoods.includes(this.selectedNeighborhoodIds[0]));
    }
      const legendArr = futureHomeFooterData.map((plan) => plan.status).toString();
      this.setLegends(legendArr);
      return futureHomeFooterData;
  }
  @Emit("recalculateSidebarHeight") recalculateSidebarHeight() {}
  updated() {
    this.recalculateSidebarHeight();
  }
}
